exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dashboard{\n  max-width:100%;\n  position: unset;\n}\n.dashboard .optionButton{\n  text-align: center;\n  margin: 28px 28px;\n}\n.dashboard .listFinder {\n  border-bottom: 1px solid #dfe6ec;\n  height: 85%;\n}\n", ""]);

// exports
